export const stateLabels = {
  active: 'Shared',
  inactive: 'Unshared',
};

export const OPENED = 'opened';
